import React from 'react';
import NvIcon from 'shared/components/nv-icon';
import { MentoringProgramContextValue } from 'athena/components/mentoring-program/context';
import { MentorshipProgramSession } from 'redux/schemas/models/mentoring-program-sessions';
import { formatSessionTime } from '../session-edit-mode/utils';

type SessionTimeViewModeProps = {
  date: MentorshipProgramSession['scheduledDate'];
  timeZone: MentoringProgramContextValue['timeZone'];
  duration: MentorshipProgramSession['duration'];
  isRecurring?: boolean;
};

const SessionTimeViewMode = React.memo(({
  date,
  timeZone,
  duration,
  isRecurring = false,
}: SessionTimeViewModeProps) => (
  <div className='d-flex pb-1 align-items-center regular'>
    {formatSessionTime(date, duration, timeZone)}
    {isRecurring && <NvIcon icon='recurring' size='smallest' className='pl-2 recurring-icon' />}
  </div>
));

export default SessionTimeViewMode;
